
import React from 'react';
import { CreateFacilityOrderTemplateModalTemplate } from 'themes/application/facility-order/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { CreateFacilityOrderTemplateModalStore } from 'application/facility-order/stores';

@setCurrentView((rootStore, componentProps) => new CreateFacilityOrderTemplateModalStore(rootStore, componentProps), 'createFacilityOrderTemplateModalStore')
@observer
class CreateFacilityOrderTemplateModal extends React.Component {
    render() {
        return <CreateFacilityOrderTemplateModalTemplate {...this.props} />
    }
}

export default CreateFacilityOrderTemplateModal;
